export const getActiveState = (states) => {
  const activeState = Object.entries(JSON.parse(states)).filter((item) => item[1].active === 1);
  if (activeState.length === 0) return null;
  return activeState[0][0];
};

export function hideNumber(string, replaceTo = "*", elemsHide = 4, sliceFromback = 4) {
  if (parseInt(string)) {
    let result = string.match(/^(\(?\+?\d{1,2}\)? ?\(?\d{1,3}\)? ?\d+\-? ?\d+\-? ?\d+)$/);
    if (result !== null) {
      var hidedNumber = Array.from(string).reduceRight(
        function (ctx, char) {
          var isDigit = char >= "0" && char <= "9";
          var offset = ctx.offset + (isDigit ? 1 : 0);
          var filteredChar = isDigit ? (offset >= 4 && offset < 8 ? "*" : char) : char;
          var filtered = filteredChar + ctx.filtered;
          return { offset: offset, filtered: filtered };
        },
        { offset: -1, filtered: "" }
      ).filtered;
      return `${string.startsWith("7") ? "+" : ""}${hidedNumber}`;
    } else {
      return string;
    }
  }
  return string;
}
